<template>
  <v-container fluid class="fullscreen">
  <v-row no-gutters>
    <v-col cols="12" md="3" class="pt-5 pl-5">
      <v-autocomplete
        v-model="userTypeAll"
        item-text="userTypeName"
        :items="userTypeAllList"
        name="userTypeaName"
        label="User Type"
        return-object
        outlined
        required
        dense
        small
        filled
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" md="12" class="ml-5">
      <v-row no-gutters>
        <v-col cols="12" md="2" class="ml-5">
          <v-row no-gutters>
            <v-col cols="12" md="12">
              <h3>Statement</h3>
            </v-col>
            <v-col cols="12" md="12">
              <v-checkbox v-model="uiAccept.debtorcreditor" label="Debtor/Credit" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.osdetail" label="Os Detail" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.delivery" label="Delivery" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.history" label="History" hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="2" class="ml-5">
          <v-row no-gutters>
            <v-col cols="12" md="12">
              <h3>Report</h3>
            </v-col>
            <v-col cols="12" md="12">
              <v-checkbox v-model="uiAccept.complete" label="Completed Report" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.salereport" label="Sale Report" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.incomereport" label="Income Report" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.expensereport" label="Expense Report" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.profitandloss" label="Profit And Loss" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.ridertimereport" label="Rider's Time" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.rideranalyzereport" label="Rider Analyze" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.restanalyzereport" label="Restaurant Analyze" hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="2" class="ml-5">
          <v-row no-gutters>
            <v-col cols="12" md="12">
              <h3>Order</h3>
            </v-col>
            <v-col cols="12" md="12">
              <v-checkbox v-model="uiAccept.neworder" label="New Order" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.orderlist" label="Order List" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.dailyriderlist" label="Daily Rider List" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.dailyriderpaylist" label="Daily Rider Payment List" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.dailyrestaurantlist" label="Daily Restaurant List" hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="2" class="ml-5">
          <v-row no-gutters>
            <v-col cols="12" md="12">
              <h3>Income/Expense</h3>
            </v-col>
            <v-col cols="12" md="12">
              <v-checkbox v-model="uiAccept.payment" label="Payment" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.income" label="Income" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.expense" label="Expense" hide-details></v-checkbox>
               <v-checkbox v-model="uiAccept.finance" label="Finance" hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="2" class="ml-5">
          <v-row no-gutters>
            <v-col cols="12" md="12">
              <h3>Setting</h3>
            </v-col>
            <v-col cols="12" md="12">
              <v-checkbox v-model="uiAccept.dailypercent" label="Daily Percent" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.restaurant" label="Restaurant" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.useraccount" label="User Account" hide-details></v-checkbox>
              <v-checkbox v-model="uiAccept.companyprofile" label="Company Profile" hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</v-container>
</template>
<script>
import accountUserService from "../service/AccountUserService";
export default {
  data: () => ({
    userTypeAll: {},
    userTypeAllList: [],
    uiAccept:{}
  }),
  props: {},
  mounted: function () {
    this.getUserType();
  },
  methods: {
    getUserType: function () {
      accountUserService
        .getUserType()
        .then((response) => {
          this.userTypeAllList.splice(0, this.userTypeAllList.length);
          this.userTypeAllList.push(...response);
          this.userTypeAll = this.userTypeAllList[2];
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
    },
    getUi: function () {
      accountUserService
        .getUi(this.userTypeAll.userTypeId)
        .then((response) => {
          this.uiAccept = Object.assign({},response);
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
    },
  },
  watch: {
    userTypeAll() {
      this.getUi();
    },
    uiAccept:{
      handler(val){
        accountUserService
        .updateUi(this.uiAccept)
        .then((response) => {
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
     },
     deep: true
    }
  },
  components: {},
};
</script>
<style scoped>
.fullscreen {
  height: 92vh;
}
</style>